import styled from "styled-components";

export default styled.div`
  .chatbot-mode-switcher {
    width: max-content;
    background-color: white;
    border-radius: 0.25em;
    padding: 0.25em;
    & button {
      border-radius: 0.25em;
      padding: 0.25em 0.75em;
    }
  }
  height: 100%;
`;
